module.exports = __webpack_public_path__ + "img/组 40@2x (1).e27d14b2.png";